import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {AbstractQuoteRow} from '../../abstract-quote-row';
import {Person} from '../../../../class/person';
import {NbCheckboxComponent} from '@nebular/theme';

@Component({
  selector: 'app-rcsquote-row',
  templateUrl: './rcsquote-row.component.html',
  styleUrls: ['./rcsquote-row.component.css']
})
export class RCSQuoteRowComponent extends AbstractQuoteRow<Person> implements OnInit {

  @Input()
  person: Person;

  @ViewChild('familyCheckbox')
  familyCheckbox: NbCheckboxComponent;

  manualCover = 0;

  constructor() {
    super();
  }

  ngOnInit() {
  }

  onRowUpdated() {
    let deltaPercent = 0;

    if (this.selectedObject.checked) {

      const maxCover = this.manualCover;

      // subtract capValue
      const deltaCover = maxCover - this.selectedCover;

      deltaPercent = Math.round((100 - ((deltaCover / maxCover) * 100)));
    }

    this.onRowUpdate.emit({value: deltaPercent, type: this.safeguardType, obj: this.getRowObject()});
  }

  getRowObject(): Person {
    return this.person;
  }

  isDisabled(): boolean {
    let ret = false;

    if (this.familyCheckbox) {
      ret = this.familyCheckbox.checked;
    }

    return ret;
  }
}
